/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGoals} from '../api'

 export const useQueryGetGoals = createReactQueryHook('getGoals', getGoals)
